import React from "react";
import {css} from "@emotion/react";

interface IProps {
    children: React.ReactNode;
    className?: string;
}

export const ResponsiveTable: React.FC<IProps> = (props) => {
    return (
        <div className={props.className} css={responsiveTable}>
            {props.children}
        </div>
    );
};

const responsiveTable = css`
    display: flex;
    flex-direction: column;
`;
import React from "react";
import {css} from "@emotion/react";

interface IProps {
    children: React.ReactNode;
    className?: string;
}

export const ResponsiveTable: React.FC<IProps> = (props) => {
    return (
        <div className={props.className} css={responsiveTable}>
            {props.children}
        </div>
    );
};

const responsiveTable = css`
    display: flex;
    flex-direction: column;
`;
